import React from "react";

type PageComponentWithLayout = {
  headerComponent?: React.ReactElement;
};

export function getLayoutProps(pageProps: React.ReactElement) {
  const Component = pageProps.type as PageComponentWithLayout;

  return {
    headerComponent: Component.headerComponent,
  };
}
